'use client'

import { useRouter } from "next/navigation"
import { Button } from "../ui/button"
import { ChevronLeft } from 'lucide-react'

export default function GoBack() {
    const router = useRouter()

    // Go back when the visitor navigated here from within the app; a fresh
    // entry (e.g. a shared profile link) falls back to the directory instead
    // of leaving the site.
    const handleBack = () => {
        const cameFromApp =
            window.history.length > 1 &&
            document.referrer.startsWith(window.location.origin)
        if (cameFromApp) {
            window.history.back()
        } else {
            router.push('/facilitators')
        }
    }

    return (
        <div className="relative z-10">
            <Button variant="secondary" onClick={handleBack} size="icon" aria-label="Go back" className="bg-white/90  cursor-pointer hover:bg-white shadow-md">
                <ChevronLeft className="h-4 w-4" />
            </Button>
        </div>
    )
}
